// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimActorDto } from './IClaimActorDto';
import {
    IClaimActorDtoFromJSON,
    IClaimActorDtoFromJSONTyped,
    IClaimActorDtoToJSON,
    IClaimActorDtoToJSONTyped,
} from './IClaimActorDto';
import type { IClaimInternalNoteResponseDto } from './IClaimInternalNoteResponseDto';
import {
    IClaimInternalNoteResponseDtoFromJSON,
    IClaimInternalNoteResponseDtoFromJSONTyped,
    IClaimInternalNoteResponseDtoToJSON,
    IClaimInternalNoteResponseDtoToJSONTyped,
} from './IClaimInternalNoteResponseDto';
import type { IClaimApprovalStatusDto } from './IClaimApprovalStatusDto';
import {
    IClaimApprovalStatusDtoFromJSON,
    IClaimApprovalStatusDtoFromJSONTyped,
    IClaimApprovalStatusDtoToJSON,
    IClaimApprovalStatusDtoToJSONTyped,
} from './IClaimApprovalStatusDto';
import type { IClaimTransferInfoDto } from './IClaimTransferInfoDto';
import {
    IClaimTransferInfoDtoFromJSON,
    IClaimTransferInfoDtoFromJSONTyped,
    IClaimTransferInfoDtoToJSON,
    IClaimTransferInfoDtoToJSONTyped,
} from './IClaimTransferInfoDto';
import type { IClaimNoteDto } from './IClaimNoteDto';
import {
    IClaimNoteDtoFromJSON,
    IClaimNoteDtoFromJSONTyped,
    IClaimNoteDtoToJSON,
    IClaimNoteDtoToJSONTyped,
} from './IClaimNoteDto';
import type { ILetterOfMedicalNecessityDto } from './ILetterOfMedicalNecessityDto';
import {
    ILetterOfMedicalNecessityDtoFromJSON,
    ILetterOfMedicalNecessityDtoFromJSONTyped,
    ILetterOfMedicalNecessityDtoToJSON,
    ILetterOfMedicalNecessityDtoToJSONTyped,
} from './ILetterOfMedicalNecessityDto';
import type { IClaimStatusDto } from './IClaimStatusDto';
import {
    IClaimStatusDtoFromJSON,
    IClaimStatusDtoFromJSONTyped,
    IClaimStatusDtoToJSON,
    IClaimStatusDtoToJSONTyped,
} from './IClaimStatusDto';
import type { IClaimEscalationNoteResponseDto } from './IClaimEscalationNoteResponseDto';
import {
    IClaimEscalationNoteResponseDtoFromJSON,
    IClaimEscalationNoteResponseDtoFromJSONTyped,
    IClaimEscalationNoteResponseDtoToJSON,
    IClaimEscalationNoteResponseDtoToJSONTyped,
} from './IClaimEscalationNoteResponseDto';
import type { IClaimPaymentAccountDto } from './IClaimPaymentAccountDto';
import {
    IClaimPaymentAccountDtoFromJSON,
    IClaimPaymentAccountDtoFromJSONTyped,
    IClaimPaymentAccountDtoToJSON,
    IClaimPaymentAccountDtoToJSONTyped,
} from './IClaimPaymentAccountDto';
import type { IClaimPostingAmountDto } from './IClaimPostingAmountDto';
import {
    IClaimPostingAmountDtoFromJSON,
    IClaimPostingAmountDtoFromJSONTyped,
    IClaimPostingAmountDtoToJSON,
    IClaimPostingAmountDtoToJSONTyped,
} from './IClaimPostingAmountDto';
import type { IActivityDetailNotificationDto } from './IActivityDetailNotificationDto';
import {
    IActivityDetailNotificationDtoFromJSON,
    IActivityDetailNotificationDtoFromJSONTyped,
    IActivityDetailNotificationDtoToJSON,
    IActivityDetailNotificationDtoToJSONTyped,
} from './IActivityDetailNotificationDto';
import type { IClaimAppealDto } from './IClaimAppealDto';
import {
    IClaimAppealDtoFromJSON,
    IClaimAppealDtoFromJSONTyped,
    IClaimAppealDtoToJSON,
    IClaimAppealDtoToJSONTyped,
} from './IClaimAppealDto';
import type { IClaimProcessingStatusDto } from './IClaimProcessingStatusDto';
import {
    IClaimProcessingStatusDtoFromJSON,
    IClaimProcessingStatusDtoFromJSONTyped,
    IClaimProcessingStatusDtoToJSON,
    IClaimProcessingStatusDtoToJSONTyped,
} from './IClaimProcessingStatusDto';

/**
 * 
 * @export
 * @interface IClaimInfoResponseDto
 */
export interface IClaimInfoResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    pay_to_type?: IClaimInfoResponseDtoPayToTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    provider_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    provider_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    payment_type?: IClaimInfoResponseDtoPaymentTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    service_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    category_type?: IClaimInfoResponseDtoCategoryTypeEnum;
    /**
     * 
     * @type {Set<number>}
     * @memberof IClaimInfoResponseDto
     */
    claim_authorization_ids?: Set<number>;
    /**
     * 
     * @type {Array<IClaimStatusDto>}
     * @memberof IClaimInfoResponseDto
     */
    claim_status_dtos?: Array<IClaimStatusDto>;
    /**
     * 
     * @type {Array<IClaimApprovalStatusDto>}
     * @memberof IClaimInfoResponseDto
     */
    claim_approval_status_dtos?: Array<IClaimApprovalStatusDto>;
    /**
     * 
     * @type {Array<IClaimProcessingStatusDto>}
     * @memberof IClaimInfoResponseDto
     */
    claim_processing_status_dtos?: Array<IClaimProcessingStatusDto>;
    /**
     * 
     * @type {Set<IActivityDetailNotificationDto>}
     * @memberof IClaimInfoResponseDto
     */
    notifications?: Set<IActivityDetailNotificationDto>;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    requested_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    approved_amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IClaimInfoResponseDto
     * @deprecated
     */
    service_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimInfoResponseDto
     */
    local_date_service_on?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimInfoResponseDto
     */
    created_at?: Date;
    /**
     * 
     * @type {IClaimActorDto}
     * @memberof IClaimInfoResponseDto
     */
    created_by?: IClaimActorDto;
    /**
     * 
     * @type {IClaimActorDto}
     * @memberof IClaimInfoResponseDto
     */
    service_for?: IClaimActorDto;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    source?: IClaimInfoResponseDtoSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    employee_provider_acc?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    patient_provider_acc?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    provider_invoice?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    organization_path?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    document_id?: number;
    /**
     * 
     * @type {Array<IClaimInternalNoteResponseDto>}
     * @memberof IClaimInfoResponseDto
     */
    claim_internal_notes?: Array<IClaimInternalNoteResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    payment_method_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IClaimInfoResponseDto
     */
    updated_at?: Date;
    /**
     * 
     * @type {Set<IClaimPostingAmountDto>}
     * @memberof IClaimInfoResponseDto
     */
    posting_amounts?: Set<IClaimPostingAmountDto>;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    amount_type?: IClaimInfoResponseDtoAmountTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoResponseDto
     */
    is_autopay?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    receipt_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    assignee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    assignment_type?: IClaimInfoResponseDtoAssignmentTypeEnum;
    /**
     * 
     * @type {IClaimEscalationNoteResponseDto}
     * @memberof IClaimInfoResponseDto
     */
    claim_escalation_note?: IClaimEscalationNoteResponseDto;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoResponseDto
     */
    is_escalated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    card_acceptor_id?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    authorization_decline_reason?: string;
    /**
     * 
     * @type {Array<IClaimTransferInfoDto>}
     * @memberof IClaimInfoResponseDto
     */
    claim_transfers?: Array<IClaimTransferInfoDto>;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    card_processor_approved_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoResponseDto
     */
    is_runout_overridden?: boolean;
    /**
     * 
     * @type {IClaimActorDto}
     * @memberof IClaimInfoResponseDto
     */
    runout_overridden_by?: IClaimActorDto;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    employee_notes?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimInfoResponseDto
     */
    apply_deductible_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoResponseDto
     */
    force_single_invoice_payment?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoResponseDto
     */
    is_offset_repayment_allowed?: boolean;
    /**
     * 
     * @type {Array<IClaimPaymentAccountDto>}
     * @memberof IClaimInfoResponseDto
     */
    claim_payment_accounts?: Array<IClaimPaymentAccountDto>;
    /**
     * 
     * @type {Array<ILetterOfMedicalNecessityDto>}
     * @memberof IClaimInfoResponseDto
     */
    letter_of_medical_necessities?: Array<ILetterOfMedicalNecessityDto>;
    /**
     * 
     * @type {Array<IClaimNoteDto>}
     * @memberof IClaimInfoResponseDto
     */
    claim_notes?: Array<IClaimNoteDto>;
    /**
     * 
     * @type {IClaimAppealDto}
     * @memberof IClaimInfoResponseDto
     */
    claim_appeal?: IClaimAppealDto;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    appealed_status_comment?: string;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    approval_status_additional_comments?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoResponseDto
     */
    initially_processed_incorrectly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimInfoResponseDto
     */
    is_transfer_needed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    current_claim_status?: IClaimInfoResponseDtoCurrentClaimStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    current_claim_approval_status?: IClaimInfoResponseDtoCurrentClaimApprovalStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof IClaimInfoResponseDto
     */
    claim_approval_status_codes?: Array<IClaimInfoResponseDtoClaimApprovalStatusCodesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    current_processing_status_type?: IClaimInfoResponseDtoCurrentProcessingStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimInfoResponseDto
     */
    current_processing_substatus_type?: IClaimInfoResponseDtoCurrentProcessingSubstatusTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoPayToTypeEnum {
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER',
    CARD_PROCESSOR = 'CARD_PROCESSOR'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoPaymentTypeEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoSourceEnum {
    WEBSITE = 'WEBSITE',
    CLAIM_PROCESSOR = 'CLAIM_PROCESSOR',
    MOBILE_APP = 'MOBILE_APP',
    ADMIN_PORTAL = 'ADMIN_PORTAL',
    FILE = 'FILE',
    PAYMENT_CARD_TRX = 'PAYMENT_CARD_TRX'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoAmountTypeEnum {
    COINSURANCE = 'COINSURANCE',
    COPAY = 'COPAY',
    PATIENT_RESPONSIBILITY = 'PATIENT_RESPONSIBILITY',
    DEDUCTIBLE = 'DEDUCTIBLE',
    MIXED = 'MIXED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoAssignmentTypeEnum {
    MANUAL = 'MANUAL',
    AUTO = 'AUTO'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoCurrentClaimStatusEnum {
    PROCESSING = 'PROCESSING',
    NEEDS_HELP = 'NEEDS_HELP',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PENDING = 'PENDING',
    REPAID = 'REPAID',
    DENIED = 'DENIED',
    DECLINED = 'DECLINED',
    REPROCESSING = 'REPROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    CANCELLED = 'CANCELLED',
    APPLIED_TO_DEDUCTIBLE = 'APPLIED_TO_DEDUCTIBLE',
    OUT_OF_POCKET = 'OUT_OF_POCKET',
    COMPLETE = 'COMPLETE',
    VOIDED = 'VOIDED',
    PAID_INELIGIBLE_EXPENSE = 'PAID_INELIGIBLE_EXPENSE',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoCurrentClaimApprovalStatusEnum {
    PENDING_REVIEW = 'PENDING_REVIEW',
    UNDER_REVIEW = 'UNDER_REVIEW',
    DOCS_NEEDED = 'DOCS_NEEDED',
    INCOMPLETE = 'INCOMPLETE',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    CANCELLED = 'CANCELLED',
    VOIDED = 'VOIDED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoClaimApprovalStatusCodesEnum {
    EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES',
    EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES',
    SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD = 'SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD',
    CLAIM_RECEIVED_AFTER_RUNOUT_DATE = 'CLAIM_RECEIVED_AFTER_RUNOUT_DATE',
    CLAIM_SUBMITTED_AFTER_GRACE_PERIOD = 'CLAIM_SUBMITTED_AFTER_GRACE_PERIOD',
    DUPLICATE_CLAIM = 'DUPLICATE_CLAIM',
    PROOF_OF_EXPENSE_NEEDED = 'PROOF_OF_EXPENSE_NEEDED',
    LETTER_OF_MEDICAL_NECESSITY_REQUIRED = 'LETTER_OF_MEDICAL_NECESSITY_REQUIRED',
    DETAILED_RECEIPT_REQUIRED = 'DETAILED_RECEIPT_REQUIRED',
    ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION = 'ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION',
    ADDITIONAL_COMMENTS = 'ADDITIONAL_COMMENTS',
    CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR = 'CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED = 'AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT',
    CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR = 'CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED',
    AUTOMATICALLY_APPROVED_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED = 'AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED',
    AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE',
    AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE',
    CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS = 'CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS',
    CLAIM_SUBMITTED_AFTER_DEADLINE = 'CLAIM_SUBMITTED_AFTER_DEADLINE',
    MEDICAL_EXPENSE_NOT_ELIGIBLE = 'MEDICAL_EXPENSE_NOT_ELIGIBLE',
    ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE = 'ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE',
    AMOUNT_NEEDED = 'AMOUNT_NEEDED',
    DATE_OF_SERVICE_NEEDED = 'DATE_OF_SERVICE_NEEDED',
    DATE_RANGE_OF_CARE_NEEDED = 'DATE_RANGE_OF_CARE_NEEDED',
    DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD = 'DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD',
    DOCUMENT_NOT_READABLE = 'DOCUMENT_NOT_READABLE',
    HANDWRITTEN_RECEIPT_NOT_SUFFICIENT = 'HANDWRITTEN_RECEIPT_NOT_SUFFICIENT',
    MERCHANT_NEEDED = 'MERCHANT_NEEDED',
    SERVICE_DESCRIPTION_NEEDED = 'SERVICE_DESCRIPTION_NEEDED',
    SERVICE_FOR_NEEDED = 'SERVICE_FOR_NEEDED',
    AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE = 'AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE',
    CUSTOM = 'CUSTOM',
    AUTOMATICALLY_APPROVED_BY_SIGIS = 'AUTOMATICALLY_APPROVED_BY_SIGIS',
    AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST = 'AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST',
    APPEAL_NOTE = 'APPEAL_NOTE'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoCurrentProcessingStatusTypeEnum {
    SUBMITTED = 'SUBMITTED',
    PAID = 'PAID',
    PARTIALLY_PAID = 'PARTIALLY_PAID',
    PROCESSING = 'PROCESSING',
    PARTIALLY_REPAID = 'PARTIALLY_REPAID',
    REPAID = 'REPAID',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    AUTHORIZED = 'AUTHORIZED',
    DECLINED = 'DECLINED',
    EXPIRED = 'EXPIRED',
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    DEDUCTIBLE_TRACKING = 'DEDUCTIBLE_TRACKING',
    ACTION_REQUIRED = 'ACTION_REQUIRED',
    STOP_PROCESSING = 'STOP_PROCESSING',
    VOIDED = 'VOIDED',
    PENDING_ACCOUNT_VERIFICATION = 'PENDING_ACCOUNT_VERIFICATION',
    REPAYMENT_INITIATED = 'REPAYMENT_INITIATED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimInfoResponseDtoCurrentProcessingSubstatusTypeEnum {
    DOCS_NEEDED = 'DOCS_NEEDED',
    CARRIER_CLAIM = 'CARRIER_CLAIM',
    WAITING_FOR_FUNDS = 'WAITING_FOR_FUNDS',
    PAYMENT_REJECTED = 'PAYMENT_REJECTED',
    REPAYMENT_REJECTED = 'REPAYMENT_REJECTED',
    PARTIAL_REPAYMENT = 'PARTIAL_REPAYMENT',
    FULL_REPAYMENT = 'FULL_REPAYMENT',
    PARTIAL_PAYMENT = 'PARTIAL_PAYMENT'
}


/**
 * Check if a given object implements the IClaimInfoResponseDto interface.
 */
export function instanceOfIClaimInfoResponseDto(value: object): value is IClaimInfoResponseDto {
    return true;
}

export function IClaimInfoResponseDtoFromJSON(json: any): IClaimInfoResponseDto {
    return IClaimInfoResponseDtoFromJSONTyped(json, false);
}

export function IClaimInfoResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimInfoResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'pay_to_type': json['pay_to_type'] == null ? undefined : json['pay_to_type'],
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'provider_name': json['provider_name'] == null ? undefined : json['provider_name'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'payment_type': json['payment_type'] == null ? undefined : json['payment_type'],
        'service_id': json['service_id'] == null ? undefined : json['service_id'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'claim_authorization_ids': json['claim_authorization_ids'] == null ? undefined : new Set(json['claim_authorization_ids']),
        'claim_status_dtos': json['claim_status_dtos'] == null ? undefined : ((json['claim_status_dtos'] as Array<any>).map(IClaimStatusDtoFromJSON)),
        'claim_approval_status_dtos': json['claim_approval_status_dtos'] == null ? undefined : ((json['claim_approval_status_dtos'] as Array<any>).map(IClaimApprovalStatusDtoFromJSON)),
        'claim_processing_status_dtos': json['claim_processing_status_dtos'] == null ? undefined : ((json['claim_processing_status_dtos'] as Array<any>).map(IClaimProcessingStatusDtoFromJSON)),
        'notifications': json['notifications'] == null ? undefined : (new Set((json['notifications'] as Array<any>).map(IActivityDetailNotificationDtoFromJSON))),
        'requested_amount': json['requested_amount'] == null ? undefined : json['requested_amount'],
        'approved_amount': json['approved_amount'] == null ? undefined : json['approved_amount'],
        'service_on': json['service_on'] == null ? undefined : (new Date(json['service_on'])),
        'local_date_service_on': json['local_date_service_on'] == null ? undefined : (new Date(json['local_date_service_on'])),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'created_by': json['created_by'] == null ? undefined : IClaimActorDtoFromJSON(json['created_by']),
        'service_for': json['service_for'] == null ? undefined : IClaimActorDtoFromJSON(json['service_for']),
        'source': json['source'] == null ? undefined : json['source'],
        'employee_provider_acc': json['employee_provider_acc'] == null ? undefined : json['employee_provider_acc'],
        'patient_provider_acc': json['patient_provider_acc'] == null ? undefined : json['patient_provider_acc'],
        'provider_invoice': json['provider_invoice'] == null ? undefined : json['provider_invoice'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'claim_internal_notes': json['claim_internal_notes'] == null ? undefined : ((json['claim_internal_notes'] as Array<any>).map(IClaimInternalNoteResponseDtoFromJSON)),
        'payment_method_id': json['payment_method_id'] == null ? undefined : json['payment_method_id'],
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'posting_amounts': json['posting_amounts'] == null ? undefined : (new Set((json['posting_amounts'] as Array<any>).map(IClaimPostingAmountDtoFromJSON))),
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'amount_type': json['amount_type'] == null ? undefined : json['amount_type'],
        'is_autopay': json['is_autopay'] == null ? undefined : json['is_autopay'],
        'receipt_id': json['receipt_id'] == null ? undefined : json['receipt_id'],
        'assignee_id': json['assignee_id'] == null ? undefined : json['assignee_id'],
        'assignment_type': json['assignment_type'] == null ? undefined : json['assignment_type'],
        'claim_escalation_note': json['claim_escalation_note'] == null ? undefined : IClaimEscalationNoteResponseDtoFromJSON(json['claim_escalation_note']),
        'is_escalated': json['is_escalated'] == null ? undefined : json['is_escalated'],
        'card_acceptor_id': json['card_acceptor_id'] == null ? undefined : json['card_acceptor_id'],
        'authorization_decline_reason': json['authorization_decline_reason'] == null ? undefined : json['authorization_decline_reason'],
        'claim_transfers': json['claim_transfers'] == null ? undefined : ((json['claim_transfers'] as Array<any>).map(IClaimTransferInfoDtoFromJSON)),
        'card_processor_approved_amount': json['card_processor_approved_amount'] == null ? undefined : json['card_processor_approved_amount'],
        'is_runout_overridden': json['is_runout_overridden'] == null ? undefined : json['is_runout_overridden'],
        'runout_overridden_by': json['runout_overridden_by'] == null ? undefined : IClaimActorDtoFromJSON(json['runout_overridden_by']),
        'employee_notes': json['employee_notes'] == null ? undefined : json['employee_notes'],
        'apply_deductible_amount': json['apply_deductible_amount'] == null ? undefined : json['apply_deductible_amount'],
        'force_single_invoice_payment': json['force_single_invoice_payment'] == null ? undefined : json['force_single_invoice_payment'],
        'is_offset_repayment_allowed': json['is_offset_repayment_allowed'] == null ? undefined : json['is_offset_repayment_allowed'],
        'claim_payment_accounts': json['claim_payment_accounts'] == null ? undefined : ((json['claim_payment_accounts'] as Array<any>).map(IClaimPaymentAccountDtoFromJSON)),
        'letter_of_medical_necessities': json['letter_of_medical_necessities'] == null ? undefined : ((json['letter_of_medical_necessities'] as Array<any>).map(ILetterOfMedicalNecessityDtoFromJSON)),
        'claim_notes': json['claim_notes'] == null ? undefined : ((json['claim_notes'] as Array<any>).map(IClaimNoteDtoFromJSON)),
        'claim_appeal': json['claim_appeal'] == null ? undefined : IClaimAppealDtoFromJSON(json['claim_appeal']),
        'appealed_status_comment': json['appealed_status_comment'] == null ? undefined : json['appealed_status_comment'],
        'approval_status_additional_comments': json['approval_status_additional_comments'] == null ? undefined : json['approval_status_additional_comments'],
        'initially_processed_incorrectly': json['initially_processed_incorrectly'] == null ? undefined : json['initially_processed_incorrectly'],
        'is_transfer_needed': json['is_transfer_needed'] == null ? undefined : json['is_transfer_needed'],
        'current_claim_status': json['current_claim_status'] == null ? undefined : json['current_claim_status'],
        'current_claim_approval_status': json['current_claim_approval_status'] == null ? undefined : json['current_claim_approval_status'],
        'claim_approval_status_codes': json['claim_approval_status_codes'] == null ? undefined : json['claim_approval_status_codes'],
        'current_processing_status_type': json['current_processing_status_type'] == null ? undefined : json['current_processing_status_type'],
        'current_processing_substatus_type': json['current_processing_substatus_type'] == null ? undefined : json['current_processing_substatus_type'],
    };
}

export function IClaimInfoResponseDtoToJSON(json: any): IClaimInfoResponseDto {
    return IClaimInfoResponseDtoToJSONTyped(json, false);
}

export function IClaimInfoResponseDtoToJSONTyped(value?: IClaimInfoResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'pay_to_type': value['pay_to_type'],
        'provider_id': value['provider_id'],
        'provider_name': value['provider_name'],
        'organization_id': value['organization_id'],
        'payment_type': value['payment_type'],
        'service_id': value['service_id'],
        'category_type': value['category_type'],
        'claim_authorization_ids': value['claim_authorization_ids'] == null ? undefined : Array.from(value['claim_authorization_ids'] as Set<any>),
        'claim_status_dtos': value['claim_status_dtos'] == null ? undefined : ((value['claim_status_dtos'] as Array<any>).map(IClaimStatusDtoToJSON)),
        'claim_approval_status_dtos': value['claim_approval_status_dtos'] == null ? undefined : ((value['claim_approval_status_dtos'] as Array<any>).map(IClaimApprovalStatusDtoToJSON)),
        'claim_processing_status_dtos': value['claim_processing_status_dtos'] == null ? undefined : ((value['claim_processing_status_dtos'] as Array<any>).map(IClaimProcessingStatusDtoToJSON)),
        'notifications': value['notifications'] == null ? undefined : (Array.from(value['notifications'] as Set<any>).map(IActivityDetailNotificationDtoToJSON)),
        'requested_amount': value['requested_amount'],
        'approved_amount': value['approved_amount'],
        'service_on': value['service_on'] == null ? undefined : ((value['service_on']).toISOString()),
        'local_date_service_on': value['local_date_service_on'] == null ? undefined : ((value['local_date_service_on']).toISOString().substring(0,10)),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'created_by': IClaimActorDtoToJSON(value['created_by']),
        'service_for': IClaimActorDtoToJSON(value['service_for']),
        'source': value['source'],
        'employee_provider_acc': value['employee_provider_acc'],
        'patient_provider_acc': value['patient_provider_acc'],
        'provider_invoice': value['provider_invoice'],
        'organization_path': value['organization_path'],
        'employee_id': value['employee_id'],
        'document_id': value['document_id'],
        'claim_internal_notes': value['claim_internal_notes'] == null ? undefined : ((value['claim_internal_notes'] as Array<any>).map(IClaimInternalNoteResponseDtoToJSON)),
        'payment_method_id': value['payment_method_id'],
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
        'posting_amounts': value['posting_amounts'] == null ? undefined : (Array.from(value['posting_amounts'] as Set<any>).map(IClaimPostingAmountDtoToJSON)),
        'external_identifier': value['external_identifier'],
        'amount_type': value['amount_type'],
        'is_autopay': value['is_autopay'],
        'receipt_id': value['receipt_id'],
        'assignee_id': value['assignee_id'],
        'assignment_type': value['assignment_type'],
        'claim_escalation_note': IClaimEscalationNoteResponseDtoToJSON(value['claim_escalation_note']),
        'is_escalated': value['is_escalated'],
        'card_acceptor_id': value['card_acceptor_id'],
        'authorization_decline_reason': value['authorization_decline_reason'],
        'claim_transfers': value['claim_transfers'] == null ? undefined : ((value['claim_transfers'] as Array<any>).map(IClaimTransferInfoDtoToJSON)),
        'card_processor_approved_amount': value['card_processor_approved_amount'],
        'is_runout_overridden': value['is_runout_overridden'],
        'runout_overridden_by': IClaimActorDtoToJSON(value['runout_overridden_by']),
        'employee_notes': value['employee_notes'],
        'apply_deductible_amount': value['apply_deductible_amount'],
        'force_single_invoice_payment': value['force_single_invoice_payment'],
        'is_offset_repayment_allowed': value['is_offset_repayment_allowed'],
        'claim_payment_accounts': value['claim_payment_accounts'] == null ? undefined : ((value['claim_payment_accounts'] as Array<any>).map(IClaimPaymentAccountDtoToJSON)),
        'letter_of_medical_necessities': value['letter_of_medical_necessities'] == null ? undefined : ((value['letter_of_medical_necessities'] as Array<any>).map(ILetterOfMedicalNecessityDtoToJSON)),
        'claim_notes': value['claim_notes'] == null ? undefined : ((value['claim_notes'] as Array<any>).map(IClaimNoteDtoToJSON)),
        'claim_appeal': IClaimAppealDtoToJSON(value['claim_appeal']),
        'appealed_status_comment': value['appealed_status_comment'],
        'approval_status_additional_comments': value['approval_status_additional_comments'],
        'initially_processed_incorrectly': value['initially_processed_incorrectly'],
        'is_transfer_needed': value['is_transfer_needed'],
        'current_claim_status': value['current_claim_status'],
        'current_claim_approval_status': value['current_claim_approval_status'],
        'claim_approval_status_codes': value['claim_approval_status_codes'],
        'current_processing_status_type': value['current_processing_status_type'],
        'current_processing_substatus_type': value['current_processing_substatus_type'],
    };
}

